import {TipoGiustificativo} from "@commons/mapping/Giustificativi";
import {ObjectFactory} from "@commons/types";
import {mergeWith} from "lodash";
import {Calc} from "@commons/mapping/Calc";
import {CoppiaTimbrature} from "@commons/mapping/CoppiaTimbrature";

export interface PresenzeGiustificativo {
    tipoGiu: TipoGiustificativo,
    valoreEvento: string,
    codGiu: string,
    quantita: number,
    quantitaHHMM: string, // contiene la quantità espressa come hhmm; solo Front-end, viene ignorata dal back-end
    quantitaValida?: boolean, // validità della quantità; solo Front-end, viene ignorata dal back-end
    oraInizio?: string,
    oraFine?: string,
    idWF: number,
    idAttestato: string,
    linked: boolean,
    readOnly: boolean,
}

function customizer(defaultValue: any, jsonValue: any, key: string, defaultObj: any, jsonObj: any) {
    /*if (key in defaultObj)
        return jsonValue;
    else return undefined;*/
    if (key === 'codGiu')
        return jsonValue.toUpperCase();
    else
        return jsonValue;
}

export class PresenzeGiustificativo {
    static maxNumGiustificativi = 5;
    static factory: ObjectFactory<PresenzeGiustificativo> = (json?) => {
        return mergeWith<PresenzeGiustificativo, Partial<PresenzeGiustificativo> | undefined>({
            tipoGiu: "ORARIO",
            valoreEvento: '',
            codGiu: '',
            quantita: 0,
            quantitaHHMM: '',
            idWF: 0,
            idAttestato: '',
            linked: false,
            readOnly: false,
            oraInizio: '',
            oraFine: '',
        }, json, customizer);
    }

    static isValid = (that: PresenzeGiustificativo|null) => {
        return (that && that.codGiu && that.codGiu.trim().length > 0);
    }
    static getKey = (that: PresenzeGiustificativo) => {
        return that.codGiu+'_'+(that.idWF||0)+'_'+(that.idAttestato||0);
    }

    /*
        static setTipoGiu = (that: PresenzeGiustificativo, tipoGiu: string) => {
            switch (tipoGiu) {
                case 'O':
                    that.tipoGiu = 'ORARIO';
                    break;
                case 'I':
                    that.tipoGiu = 'IMPORTO';
                    break;
                case 'Q':
                    that.tipoGiu = 'QUANTITA';
                    break;
                case 'E':
                    that.tipoGiu = 'EVENTO';
                    break;
                default:
                    that.tipoGiu = tipoGiu;
                    break;
            }
        };
    */

    static setHHCC = function (giu: PresenzeGiustificativo, hhcc: number) {
        giu.quantita = hhcc;
        let parts = Calc.getParts(hhcc * 100);
        if (parts) {
            const minuti = Math.round(60 * parts.frazione / 100);
            const sMin = "00" + minuti;
            //let s = "0000" + parts.ore + sMin.substr(-2);
            const s = "0000" + parts.ore + sMin.substring(sMin.length - 2);
            //giu.quantitaHHMM = s.substr(-4);
            giu.quantitaHHMM = s.substring(s.length - 4);
        } else
            giu.quantitaHHMM = '';
    };

    static getIntervallo(giu: PresenzeGiustificativo): null | CoppiaTimbrature {
        if (parseInt(giu.oraInizio || '0') !== 0 || parseInt(giu.oraFine || '0') !== 0) {
            const coppia = CoppiaTimbrature.factory({entrata: giu.oraInizio, uscita: giu.oraFine});
            return coppia;
        } else return null
    }
}